'use client';

/** @jsxImportSource @emotion/react */
import {
  Chip,
  Container,
  FlexItem,
  FlexLayout,
  LazyBackground,
  Typography,
  useTheme,
} from '@wci-tech/core-ui';
import { useTranslations } from 'next-intl';
import { useStyles } from './AboutUs.styles';
import { getCommonChipStyles } from '@/styles/Common.styles';
import { useThemeMode } from '@/context';

const AboutUs = () => {
  const { isDark } = useThemeMode();
  const t = useTranslations('AboutUs');
  const { theme } = useTheme();
  const commonChip = getCommonChipStyles(theme);

  const styles = useStyles();
  const desktopImg = isDark ? './images/aboutDesktopDark.png' : './images/aboutDesktopLight.png';
  const tabletImg = isDark ? './images/aboutTabletDark.png' : './images/aboutTabletLight.png';
  const mobileImg = isDark ? './images/aboutMobileDark.png' : './images/aboutMobileLight.png';

  return (
    <section css={styles.wrapper} id="about">
      <LazyBackground
        desktopImgSrc={desktopImg}
        tabletImgSrc={tabletImg}
        mobileImgSrc={mobileImg}
        customStyles={{
          width: '100%',
        }}
      >
        <Container css={styles.container}>
          <FlexLayout
            direction="column"
            alignItems="center"
            gap={{
              default: 0,
            }}
            padding={{ default: 0 }}
          >
            {/* Section Chip */}
            <FlexItem>
              <Chip
                label={t('chipLabel')}
                enableHoverEffect={false}
                customStyles={{
                  chipContainer: commonChip.chipContainer,
                  label: commonChip.chipLabel,
                }}
              />
            </FlexItem>

            {/* Main Header */}
            <FlexItem css={styles.headerSection}>
              <FlexLayout direction="column" alignItems="center" gap={16} padding={{ default: 0 }}>
                <Typography variant="h2" customStyles={styles.title}>
                  {t('title')}
                </Typography>

                <Typography variant="p" customStyles={styles.description}>
                  {t('description')}
                </Typography>
              </FlexLayout>
            </FlexItem>

            {/* Vision and Mission Content */}
            <FlexItem alignSelf="flex-start">
              <FlexLayout
                direction="column"
                alignItems="flex-start"
                gap={{
                  default: 36,
                  md: 56,
                  lg: 80,
                }}
                padding={{ default: 0 }}
              >
                {/* Vision Section */}
                <FlexItem css={styles.visionSection}>
                  <Typography variant="h3" customStyles={styles.visionTitle}>
                    {t('vision.title')}
                  </Typography>

                  <Typography variant="p" customStyles={styles.visionDescription}>
                    {t('vision.description')}
                  </Typography>
                </FlexItem>

                {/* Mission Section */}
                <FlexItem css={styles.visionSection}>
                  <Typography variant="h3" customStyles={styles.visionTitle}>
                    {t('mission.title')}
                  </Typography>

                  <Typography variant="p" customStyles={styles.visionDescription}>
                    {t('mission.description')}
                  </Typography>
                </FlexItem>
              </FlexLayout>

              {/* Closing Quote */}
              <Typography variant="blockquote" customStyles={styles.quotes}>
                {t('quote')}
              </Typography>
            </FlexItem>
          </FlexLayout>
        </Container>
      </LazyBackground>
    </section>
  );
};

export default AboutUs;
